export default __webpack_public_path__ + "static/media/correspondent21.ab8e6a44.png";